import React, { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./LoginPage.css";
import FRONTEND_CONFIG from "./frontend_config";

const UserLogin_Page = () => {
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(""); 
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await axios.post(`${FRONTEND_CONFIG.API_URL}/api/user/login`, {
        email,
        password,
      });

      if (res.status === 200) {
        const { user, token } = res.data;

        // Normalize _id so all pages can use user._id safely
        const normalizedUser = { ...user, _id: user._id || user.id };

        // Save token & user data
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(normalizedUser));

        // ✅ Show toast instead of alert
        setToast(`Welcome ${normalizedUser.name}! Redirecting to your ${normalizedUser.role} dashboard...`);

        // Hide toast after 2 seconds
        setTimeout(() => setToast(""), 2000);

        // Role-based redirect after 2 seconds
        setTimeout(() => {
          switch (normalizedUser.role) {
            case "lecture":
              navigate("/lecture-dashboard");
              break;
            case "examsection":
              navigate("/examsection-dashboard");
              break;
            case "admin":
              navigate("/admin-dashboard");
              break;
            default:
              navigate("/user-dashboard");
              break;
          }
        }, 2000);
      }

    } catch (err) {
      if (err.response) {
        setError(err.response.data.message || "Invalid credentials. Try again.");
      } else {
        setError("Server not reachable. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-box">
        <div className="left-section">
          <h2>Login</h2>

          <form onSubmit={handleSubmit}>
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Enter your email"
            />

            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter your password"
            />

            {error && <p className="error-msg">{error}</p>}

            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? "Logging in..." : "Login"}
            </button>

            <p className="signup-text">
              Don't have an account?{" "}
              <span
                className="signup-link"
                onClick={() => navigate("/signup")}
              >
                Sign Up
              </span>
            </p>
          </form>
        </div>

        <div className="right-section">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h1>WELCOME</h1>
            <p>To our Exam Portal.</p>
          </motion.div>
        </div>
      </div>

      {/* ✅ Toast for success message */}
      {toast && <div className="toast">{toast}</div>}
    </div>
  );
};

export default UserLogin_Page;
